import * as yup from 'yup'

import { FormFields } from './types'

export const validationSchema = yup.object().shape({
  [FormFields.text]: yup.string().required().max(30),
})
